
































import { Component, Prop, Vue, Watch } from 'vue-property-decorator'
import { formatDate, convertMoment } from '../utils/helpers'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { InputInterface } from '../types/Exa_Input'

@Component({
    components: {
        FontAwesomeIcon
    }
})
export default class InputDateTime extends Vue {
    formatDate = formatDate
    @Prop() private libelle!: string
    @Prop() private description!: string
    @Prop() private value!: any
    @Prop() private data!: { min: any; max: any }
    @Prop() private ident!: any
    @Prop() private requis!: boolean
    @Prop() private disabled!: boolean
    @Prop() mode_lecture!: boolean
    @Prop() condition!: InputInterface
    @Prop({ default: false }) check_validation!: boolean

    inputValidity = ''

    @Watch('value', { immediate: true, deep:true })
    checkDate () {
        this.inputValidity = ''
        if (this.data && this.value !== null) {
            if (this.data.min !== undefined && this.data.min !== null && this.data.min !== '' && convertMoment(this.value) < convertMoment(this.data.min)) {
                this.inputValidity =  'Cette date doit être égale ou postérieure au ' + convertMoment(this.data.min).format('DD/MM/YYYY - HH:mm') + '.'
            } else if (this.data.max !== undefined && this.data.max !== null && this.data.max !== '' && convertMoment(this.value) > convertMoment(this.data.max)) {
                this.inputValidity =  'Cette date doit être égale ou antérieure au ' + convertMoment(this.data.max).format('DD/MM/YYYY - HH:mm') + '.' 
            }
            this.$emit('anomalieHandler', { ident: this.ident, anomalie: this.inputValidity })
        }
    }

    /** 
     * inputHandler 
     * Gère les modifications de saisie de l'entrée en émettant un événement avec la valeur de la cible. 
     * @param {any} e - L'événement de saisie. 
     */
    inputHandler(e: any) {
        this.inputValidity = ''
        if (this.data && e.target.value !== null) {
            if (this.data.min !== null && convertMoment(e.target.value) < convertMoment(this.data.min)) {
                this.inputValidity =  'Cette date doit être égale ou postérieure au ' + convertMoment(this.data.min).format('DD/MM/YYYY - HH:mm') + '.'
            } else if (this.data.max !== null && convertMoment(e.target.value) > convertMoment(this.data.max)) {
                this.inputValidity =  'Cette date doit être égale ou antérieure au ' + convertMoment(this.data.max).format('DD/MM/YYYY - HH:mm') + '.' 
            }
            this.$emit('anomalieHandler', { ident: this.ident, anomalie: this.inputValidity })
        }
        this.$emit('input', { ident: this.ident, value: e.target.value })
    }
}
